// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3OZDo","content":"Consent_content__VFt8w","footer":"Consent_footer__2UDay"};